<template>
    <div class="modules_college">
        <HeaderSivoaVue />

        <div class="modules_container" v-if="!registering_done">
            <router-link to="/">
                <img src="./images/ModulesCollege/accueil.svg" alt="accueil" height="20px" width="68px" />
            </router-link>
            <div class="modules_title0">DEMANDE D'INSCRIPTION AUX <span id="modules_orange_text">MODULES COLL&Egrave;GE</span></div>
            <div class="modules_title0">DU SYNDICAT DE L'ORGE</div>
            
            <img src="./images/ModulesCollege/attention.svg" alt="attention" height="16px" width="16px"/>&nbsp;<span style="color: rgb(237, 28, 36); text-transform: uppercase;">Remplir 1 formulaire par classe</span>
            <div style="height: 20px;"></div>

            <div class="w3-container w3-round-xlarge" style="background-color: #EC7404; padding-top: 16px;">
                <div class="w3-row">
                    <div class="w3-container w3-half w3-mobile">
                        <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-size: 12px; color: white;">
                            INFORMATIONS SUR LE COLL&Egrave;GE
                        </div>
                        <div class="w3-row">
                            <!--<input id="school_city" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font" v-model="school_city" placeholder="Sélectionnez la ville du collège *">-->
                            <select required id="school_city" v-on:change="selectCity()" v-model="school_city" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font">
                                <option value="" disabled selected>Sélectionnez la ville du collège *</option>
                                <option v-for="item in city_list" v-bind:key="item.id" v-bind:value="item.city_name">{{ item.city_name }}</option>
                            </select>
                        </div>
                        <div class="w3-row">
                            <select required id="school_name_id" v-on:change="selectSchool()" v-model="school_name_id" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font">
                                <option value="-1" disabled selected>Sélectionnez le nom du collège *</option>
                                <option v-for="item in school_list" v-bind:key="item.id" v-bind:value="item.id">{{ item.school_name }} ({{ item.school_city }})</option>
                            </select>

                        </div>
                        <div class="w3-row">
                            <input id="school_address" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font" v-model="school_address" :readonly="true" placeholder="Adresse du collège *">
                        </div>
                        <div class="w3-row">
                            <input id="school_phone" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font" v-model="school_phone" :readonly="true" placeholder="Téléphone du collège *" maxlength="32">
                        </div>

                    </div>

                    <div class="w3-container w3-half w3-mobile">
                        <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-size: 12px; color: white;">
                            INFORMATIONS SUR LA CLASSE
                        </div>
                        <div class="w3-row">
                            <div class="w3-container w3-half w3-mobile" style="padding: 2px;">
                                <input id="school_class" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font" v-model="school_class" placeholder="Niveau *">
                            </div>
                            <div class="w3-container w3-half w3-mobile" style="padding: 2px;">
                                <!--<input id="school_pupils_nb" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font" type="number" v-model.number="school_pupils_nb" placeholder="Nombre d'élèves *">-->
                                <select required id="school_pupils_nb" v-model="school_pupils_nb" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font">
                                    <option value="-1" disabled selected>Nombre d'élèves *</option>
                                    <option v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
                                    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40]" v-bind:key="i" v-bind:value="i">{{ i }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="w3-row">&nbsp;</div>
                        <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-size: 12px; color: white;">
                            INFORMATIONS SUR L'ENSEIGNANT
                        </div>
                        <div class="w3-row">
                            <input type="radio" id="modules_radio_button_civility_mme" value="Mme" style="margin-left:0px;" v-model="civility_check">
                            <label for="modules_radio_button_civility_mme" class="modules_radio_button modules_textbox_font" style="margin-left: 5px; color: white;">Mme</label>
                            &nbsp;&nbsp;
                            <input type="radio" id="modules_radio_button_civility_m" value="M." v-model="civility_check">
                            <label for="modules_radio_button_civility_m" class="modules_radio_button modules_textbox_font" style="margin-left: 5px; color: white;">M.</label>
                        </div>
                        <div class="w3-row">
                            <input id="school_teacher" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font" v-model="school_teacher" placeholder="Nom de l'enseignant *">
                        </div>
                        <div class="w3-row">
                            <div class="w3-container w3-half w3-mobile" style="padding: 2px;">
                                <input id="school_teacher_email" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font" v-model="school_teacher_email" placeholder="Mail de l'enseignant *">
                            </div>
                            <div class="w3-container w3-half w3-mobile" style="padding: 2px;">
                                <input id="school_teacher_mobile" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom modules_textbox_font" v-model="school_teacher_mobile" placeholder="Numéro de portable de l'enseignant *">
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="w3-row">
                    <div class="w3-container w3-mobile w3-right">
                        <div class="mandatory_info_text">* Champs obligatoires</div>
                    </div>
                </div>
                <div class="w3-row">&nbsp;</div>
            </div>

            <div style="height: 20px;"></div>
            <div class="modules_title1">LES MODULES</div>
            <div class="modules_title2">Chaque module comprend plusieurs ateliers qui se déroulent en classe ou en extérieur.</div>
            <div class="modules_title2">Choisissez au <strong>maximum 6h d'ateliers</strong> par classe.</div>
            <div style="margin-bottom: 20px;"></div>

            <div>
                <div style="float: left;">Nombre d'heures sélectionnées &nbsp;</div>
                <div style="float: left; border: 1px solid; background-color: white; color: rgb(236, 116, 4); text-align: center; line-height: 16px; height: 20px; width: 20px;">{{ ComputeSelectedWorkshopsHours() }}</div>
                <div style="float: left;">&nbsp;&nbsp;&nbsp; Nombre d'heures restantes &nbsp;</div>
                <div style="float: left; border: 1px solid; background-color: white; color: rgb(236, 116, 4); text-align: center; line-height: 16px; height: 20px; width: 20px;">{{ 6-ComputeSelectedWorkshopsHours() }}</div>
            </div>
            <div style="clear: both; height: 20px;"></div>

            <div class="w3-row-padding w3-stretch">
                <div class="w3-half w3-container w3-mobile">
                    <div class="modules_title3">Modules à suivre intégralement ou avec ateliers au choix :</div>

                    <div class="modules_choices_section0_box">
                        <div class="w3-row" v-if="this.workshops_to_attend_responsible_consommation.length==2">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" :checked="this.workshops_to_attend_responsible_consommation.length==2" v-on:click="selectAllResponsibleConsommation()" />
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_selected" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Consommation responsable - 4h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else-if="ComputeSelectedWorkshopsHours() >= 3">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" disabled v-on:click="selectAllResponsibleConsommation()" />
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Consommation responsable - 4h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else>
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" :checked="this.workshops_to_attend_responsible_consommation.length==2" v-on:click="selectAllResponsibleConsommation()" />
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item" style="width: 90%;">
                                <span class="modules_choices_choice_title2">Module Consommation responsable - 4h</span>
                            </div>
                        </div>

                        <div class="w3-row">
                            <div class="modules_choices_choice_text0">Acquérir des comportements éco-responsables pour préserver la ressource en eau.</div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-if="this.workshops_to_attend_responsible_consommation.includes('atelier 1')">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 1" v-model="workshops_to_attend_responsible_consommation" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item_selected" style="width: 90%;" >
                                <span><strong>Atelier 1</strong> &nbsp;</span>
                                <span>Le cycle de l’eau domestique &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-else-if="ComputeSelectedWorkshopsHours() <= 4">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 1" v-model="workshops_to_attend_responsible_consommation" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>                      
                            <div class="w3-rest workshops_choices_choice_item" style="width: 90%;">
                                <span style="color: #000000; color: rgb(0, 0, 0);"><strong>Atelier 1</strong> &nbsp;</span>
                                <span>Le cycle de l’eau domestique &nbsp;</span>
                                <span style="color: #000000; color: rgb(0, 0, 0);">2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-else>
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" :disabled="ComputeSelectedWorkshopsHours() > 4" value="atelier 1" v-model="workshops_to_attend_responsible_consommation" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;" >
                                <span><strong>Atelier 1</strong> &nbsp;</span>
                                <span>Le cycle de l’eau domestique &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>


                        <div class="w3-row" style="display: flex; align-items: center;" v-if="this.workshops_to_attend_responsible_consommation.includes('atelier 2')">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 2" v-model="workshops_to_attend_responsible_consommation" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item_selected" style="width: 90%;" >
                                <span><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La station d’épuration &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-else-if="ComputeSelectedWorkshopsHours() <= 4">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 2" v-model="workshops_to_attend_responsible_consommation" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item" style="width: 90%;" >
                                <span style="color: #000000; color: rgb(0, 0, 0);"><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La station d’épuration &nbsp;</span>
                                <span style="color: #000000; color: rgb(0, 0, 0);">2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-else>
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" :disabled="ComputeSelectedWorkshopsHours() > 4" value="atelier 2" v-model="workshops_to_attend_responsible_consommation" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;" >
                                <span><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La station d’épuration &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                    </div>


                    <div class="modules_choices_section0_box">
                        <div class="w3-row" v-if="this.workshops_to_attend_anthropogenic_impacts_on_natural_env.length==2">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" :checked="this.workshops_to_attend_anthropogenic_impacts_on_natural_env.length==2" v-on:click="selectAllAnthropogenicImpactsOnNaturalEnv()"/>
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_selected" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Impacts anthropiques - 4h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else-if="ComputeSelectedWorkshopsHours() >= 3">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" disabled v-on:click="selectAllAnthropogenicImpactsOnNaturalEnv()"/>
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Impacts anthropiques - 4h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else>
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" :checked="this.workshops_to_attend_anthropogenic_impacts_on_natural_env.length==2" v-on:click="selectAllAnthropogenicImpactsOnNaturalEnv()"/>
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item" style="width: 90%;">
                                <span class="modules_choices_choice_title2">Module Impacts anthropiques - 4h</span>
                            </div>
                        </div>

                        <div class="w3-row">
                            <div class="modules_choices_choice_text0">Comprendre comment l’urbanisation et nos comportements affectent les milieux naturels.</div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-if="this.workshops_to_attend_anthropogenic_impacts_on_natural_env.includes('atelier 1')">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 1" v-model="workshops_to_attend_anthropogenic_impacts_on_natural_env" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item_selected" style="width: 90%;" >
                                <span><strong>Atelier 1</strong> &nbsp;</span>
                                <span>L’Orge et le risque inondation &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-else-if="ComputeSelectedWorkshopsHours() <= 4">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 1" v-model="workshops_to_attend_anthropogenic_impacts_on_natural_env" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item" style="width: 90%;" >
                                <span style="color: #000000; color: rgb(0, 0, 0);"><strong>Atelier 1</strong> &nbsp;</span>
                                <span>L’Orge et le risque inondation &nbsp;</span>
                                <span style="color: #000000; color: rgb(0, 0, 0);">2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;"  v-else>
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" :disabled="ComputeSelectedWorkshopsHours() > 4" value="atelier 1" v-model="workshops_to_attend_anthropogenic_impacts_on_natural_env" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span><strong>Atelier 1</strong> &nbsp;</span>
                                <span>L’Orge et le risque inondation &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>

                        <div class="w3-row" style="margin-left: 30px; margin-top: 10px; margin-bottom: 10px;">
                            <div style="display: flex; align-items: top;">
                                <img src="./images/ModulesCollege/attention.svg" alt="attention" height="32px" width="32px" style="margin-right: 10px;" />
                                <span style="font-family: Arial; font-size: 16px; color: rgb(237, 28, 36);">
                                    Cette sortie sur le terrain se déroule sur un site du Syndicat de l'Orge. Prévoir un moyen de transport pour y accéder si le collège est éloigné du site.
                                </span>
                            </div>
                            <div onclick="window.open('https://sivoa91.maps.arcgis.com/apps/View/index.html?appid=dab2e36734d747178df45e46b65b9631', '_blank');" style="display: flex; align-items: center; cursor: pointer;">
                                <img src="./images/ModulesCollege/carte.svg" alt="appli_carte" height="30px" width="30px" style="margin-right: 10px;" />
                                <div style="font-family: Arial; font-size: 16px; color: rgb(112, 74, 56);">				
                                    <div>Simulez votre itinéraire</div>
                                </div>
                            </div>
                        </div>

                        <div class="w3-row" style="display: flex; align-items: center;" v-if="this.workshops_to_attend_anthropogenic_impacts_on_natural_env.includes('atelier 2')">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 2" v-model="workshops_to_attend_anthropogenic_impacts_on_natural_env" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item_selected" style="width: 90%;">
                                <span><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La pollution des cours d’eau &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;"  v-else-if="ComputeSelectedWorkshopsHours() <= 4">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 2" v-model="workshops_to_attend_anthropogenic_impacts_on_natural_env" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item" style="width: 90%;">
                                <span style="color: #000000; color: rgb(0, 0, 0);"><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La pollution des cours d’eau &nbsp;</span>
                                <span style="color: #000000; color: rgb(0, 0, 0);">2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-else>
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" :disabled="ComputeSelectedWorkshopsHours() > 4" value="atelier 2" v-model="workshops_to_attend_anthropogenic_impacts_on_natural_env" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;" >
                                <span><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La pollution des cours d’eau &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                    </div>


                    <div class="modules_choices_section0_box">
                        <div class="w3-row" v-if="this.workshops_to_attend_biodiversity.length==3">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" :checked="this.workshops_to_attend_biodiversity.length==3" v-on:click="selectAllBiodiversity()" />
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_selected" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Biodiversité - 6h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else-if="ComputeSelectedWorkshopsHours() >= 3">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" disabled v-on:click="selectAllBiodiversity()" />
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Biodiversité - 6h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else>
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="brown_container">
                                    <input type="checkbox" :checked="this.workshops_to_attend_biodiversity.length==3" v-on:click="selectAllBiodiversity()" />
                                    <span class="brown_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item" style="width: 90%;">
                                <span class="modules_choices_choice_title2">Module Biodiversité - 6h</span>
                            </div>
                        </div>

                        <div class="w3-row">
                            <div class="modules_choices_choice_text0">Découvrir la faune et la flore des milieux humides de la vallée.</div>
                        </div>

                        <div class="w3-row" style="margin-left: 30px; margin-top: 10px; margin-bottom: 10px;">
                            <div style="display: flex; align-items: top;">
                                <img src="./images/ModulesCollege/attention.svg" alt="attention" height="32px" width="32px" style="margin-right: 10px;" />
                                <span style="font-family: Arial; font-size: 16px; color: rgb(237, 28, 36);">
                                    Ces ateliers sur le terrain se déroulent sur un site du Syndicat de l'Orge. Prévoir un moyen de transport pour y accéder si le collège est éloignée du site.
                                </span>
                            </div>
                            <div onclick="window.open('https://sivoa91.maps.arcgis.com/apps/View/index.html?appid=dab2e36734d747178df45e46b65b9631', '_blank');" style="display: flex; align-items: center; cursor: pointer;">
                                <img src="./images/ModulesCollege/carte.svg" alt="appli_carte" height="30px" width="30px" style="margin-right: 10px;" />
                                <div style="font-family: Arial; font-size: 16px; color: rgb(112, 74, 56);">				
                                    <div>Simulez votre itinéraire</div>
                                </div>
                            </div>
                        </div>

                        <div class="w3-row" style="display: flex; align-items: center;" v-if="this.workshops_to_attend_biodiversity.includes('atelier 1')">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 1" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item_selected" style="width: 90%;" >
                                <span><strong>Atelier 1</strong> &nbsp;</span>
                                <span>Les plantes sauvages &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;"   v-else-if="ComputeSelectedWorkshopsHours() <= 4">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 1" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item" style="width: 90%;">
                                <span style="color: #000000; color: rgb(0, 0, 0);"><strong>Atelier 1</strong> &nbsp;</span>
                                <span>Les plantes sauvages &nbsp;</span>
                                <span style="color: #000000; color: rgb(0, 0, 0);">2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;"  v-else>
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" :disabled="ComputeSelectedWorkshopsHours() > 4" value="atelier 1" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span><strong>Atelier 1</strong> &nbsp;</span>
                                <span>Les plantes sauvages &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>

                        <div class="w3-row" style="display: flex; align-items: center;" v-if="this.workshops_to_attend_biodiversity.includes('atelier 2')">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 2" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item_selected" style="width: 90%;" >
                                <span><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La microfaune aquatique &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;"  v-else-if="ComputeSelectedWorkshopsHours() <= 4">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 2" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item" style="width: 90%;" >
                                <span style="color: #000000; color: rgb(0, 0, 0);"><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La microfaune aquatique &nbsp;</span>
                                <span style="color: #000000; color: rgb(0, 0, 0);">2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;"  v-else>
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" :disabled="ComputeSelectedWorkshopsHours() > 4" value="atelier 2" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span><strong>Atelier 2</strong> &nbsp;</span>
                                <span>La microfaune aquatique &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>

                        <div class="w3-row" style="display: flex; align-items: center;" v-if="this.workshops_to_attend_biodiversity.includes('atelier 3')">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 3" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item_selected" style="width: 90%;" >
                                <span><strong>Atelier 3</strong> &nbsp;</span>
                                <span>Les oiseaux d’eau &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;"  v-else-if="ComputeSelectedWorkshopsHours() <= 4">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" value="atelier 3" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest workshops_choices_choice_item" style="width: 90%;">
                                <span style="color: #000000; color: rgb(0, 0, 0);"><strong>Atelier 3</strong> &nbsp;</span>
                                <span>Les oiseaux d’eau &nbsp;</span>
                                <span style="color: #000000; color: rgb(0, 0, 0);">2h &nbsp;</span>
                            </div>
                        </div>
                        <div class="w3-row" style="display: flex; align-items: center;" v-else>
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                <label class="container">
                                    <input type="checkbox" :disabled="ComputeSelectedWorkshopsHours() > 4" value="atelier 3" v-model="workshops_to_attend_biodiversity" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span><strong>Atelier 3</strong> &nbsp;</span>
                                <span>Les oiseaux d’eau &nbsp;</span>
                                <span>2h &nbsp;</span>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="w3-half w3-mobile">
                    <div class="modules_title4">Modules à suivre intégralement : </div>
                    <div class="modules_choices_section1_box">
                      
                        <div class="w3-row"  v-if="this.workshops_to_attend_climate_change.length > 0">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="blue_container">
                                    <input type="checkbox" value="atelier 1 2 3" v-model="workshops_to_attend_climate_change" />
                                    <span class="blue_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_right_choices_choice_item_selected" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Changement climatique - 3h</span>
                            </div>
                        </div>
                        <div class="w3-row"  v-else-if="ComputeSelectedWorkshopsHours() >= 4">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="blue_container">
                                    <input type="checkbox" disabled value="atelier 1 2 3" v-model="workshops_to_attend_climate_change" />
                                    <span class="blue_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Changement climatique - 3h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else>
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="blue_container">
                                    <input type="checkbox" value="atelier 1 2 3" v-model="workshops_to_attend_climate_change" />
                                    <span class="blue_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_right_choices_choice_item" style="width: 90%;">
                                <span class="modules_choices_choice_title_section1">Module Changement climatique - 3h</span>
                            </div>
                        </div>

                        <div class="w3-row">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                            </div>
                            <div class="w3-rest">
                                <div class="modules_choices_choice_text0_section1">(à partir de la 5ème)<br>Appréhender de façon globale le changement climatique et trouver des solutions concrètes.</div>
                                <div class="w3-row">
                                    <div class="w3-col l2 m4 s4 modules_choices_choice_item_checkbox_text">Atelier 1</div>
                                    <div class="w3-rest modules_choices_choice_item_text">Comprendre le changement climatique <span style="color: #000000; color: rgb(0, 0, 0);">1h</span></div>
                                </div>
                                <div class="w3-row">
                                    <div class="w3-col l2 m4 s4 modules_choices_choice_item_checkbox_text">Atelier 2</div>
                                    <div class="w3-rest modules_choices_choice_item_text">Les impacts du changement climatique <span style="color: #000000; color: rgb(0, 0, 0);">1h</span></div>
                                </div>
                                <div class="w3-row">
                                    <div class="w3-col l2 m4 s4 modules_choices_choice_item_checkbox_text">Atelier 3</div>
                                    <div class="w3-rest modules_choices_choice_item_text">A nous d’agir ! <span style="color: #000000; color: rgb(0, 0, 0);">1h</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modules_choices_section1_box">

                        <div class="w3-row" v-if="this.workshops_to_attend_water_issues_around_the_world.length > 0">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="blue_container">
                                    <input type="checkbox" value="atelier 1 2" v-model="workshops_to_attend_water_issues_around_the_world" />
                                    <span class="blue_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_right_choices_choice_item_selected" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Enjeux de l’eau dans le monde - 2h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else-if="ComputeSelectedWorkshopsHours() >= 5">
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="blue_container">
                                    <input type="checkbox" disabled value="atelier 1 2" v-model="workshops_to_attend_water_issues_around_the_world" />
                                    <span class="blue_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_choices_choice_item_disabled" style="width: 90%;">
                                <span style="font-size: 18px; font-weight: bold;">Module Enjeux de l’eau dans le monde - 2h</span>
                            </div>
                        </div>
                        <div class="w3-row" v-else>
                            <div class="w3-col" style="margin-top: 12px; margin-right: 5px; height: 30px; width: 30px; float: left;">
                                <label class="blue_container">
                                    <input type="checkbox" value="atelier 1 2" v-model="workshops_to_attend_water_issues_around_the_world" />
                                    <span class="blue_checkmark"></span>
                                </label>
                            </div>
                            <div class="w3-rest modules_right_choices_choice_item" style="width: 90%;">
                                <span class="modules_choices_choice_title_section1">Module Enjeux de l’eau dans le monde - 2h</span>
                            </div>
                        </div>

                        <div class="w3-row">
                            <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                            </div>
                            <div class="w3-rest">
                                <div class="modules_choices_choice_text0_section1">Identifier les problèmes d'accès à l'eau potable et à l'assainissement pour certains pays autour d'un jeu.</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modules_title6">VOS DISPONIBILIT&Eacute;S</div>
            <div class="w3-row w3-stretch w3-margin-bottom">
                <div class="w3-row w3-container">
                    <div class="modules_availabilities_section_title">Indiquez les jours de la semaine et les créneaux horaires au cours desquels les ateliers pourraient être réalisés (entre 9h30 et 12h30 et entre 14h et 17h) :</div>


            <div class="w3-cell-row w3-mobile">
				<img src="./images/ModulesCollege/attention.svg" alt="attention" height="16px" width="16px"/>
				<span style="color: rgb(237, 28, 36); text-transform: uppercase;">&nbsp;pour la plupart des ateliers prévoir des créneaux de 2h consécutives</span>
            </div>

                    <div style="margin-bottom: 16px;"></div>

                    <div class="w3-row-padding w3-section w3-stretch" style="background: rgba(235, 235, 235, 1); border-radius: 20px; -moz-border-radius: 20px; -webkit-border-radius: 20px; padding-left: 16px; padding-right: 16px; padding-top: 16px; padding-bottom: 0px; margin-bottom: 10px;">
                        <div class="w3-row">
                            <div class="w3-container w3-half w3-mobile" style="padding: 10px;">
                                <div class="w3-padding w3-white w3-round-medium w3-margin-bottom">
                                    <div class="w3-row">
                                        <div class="w3-quarter">
                                            <span style="padding-right: 50px; font-family: Arial; font-weight: bold; font-size: 18px; text-transform: uppercase; color: rgb(236, 116, 4); margin-bottom: 10px;">
                                                LUNDI*
                                            </span>
                                        </div>
                                        <div class="w3-rest">
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="monday_yes" value="1" v-model="schedule_monday_checked">&nbsp;
                                                <label for="monday_yes">Oui</label>
                                            </span>
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="monday_no" value="0" v-model="schedule_monday_checked">&nbsp;
                                                <label for="monday_no">Non</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="w3-row">
                                        <input id="monday_schedule_hours"  class="w3-input" style="border: 1px solid lightgrey; border-radius: 5px; padding: 5px; background-color: white; color: grey;" v-if="schedule_monday_checked==1" v-model="schedule_monday_hours" placeholder="Précisez horaires et semaine A ou B :">
                                    </div>
                                </div>
                            </div>

                            <div class="w3-container w3-half w3-mobile" style="padding: 10px;">
                                <div class="w3-padding w3-white w3-round-medium w3-margin-bottom">
                                    <div class="w3-row">
                                        <div class="w3-quarter">
                                            <span style="padding-right: 50px; font-family: Arial; font-weight: bold; font-size: 18px; text-transform: uppercase; color: rgb(236, 116, 4); margin-bottom: 10px;">
                                                MARDI*
                                            </span>
                                        </div>
                                        <div class="w3-rest">
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="tuesday_yes" value="1" v-model="schedule_tuesday_checked">&nbsp;
                                                <label for="tuesday_yes">Oui</label>
                                            </span>
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="tuesday_no" value="0" v-model="schedule_tuesday_checked">&nbsp;
                                                <label for="tuesday_no">Non</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="w3-row">
                                        <input id="tuesday_schedule_hours"  class="w3-input" style="border: 1px solid lightgrey; border-radius: 5px; padding: 5px; background-color: white; color: grey;" v-if="schedule_tuesday_checked==1" v-model="schedule_tuesday_hours" placeholder="Précisez horaires et semaine A ou B :">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w3-row">
                            <div class="w3-container w3-half w3-mobile" style="padding: 10px;">
                                <div class="w3-padding w3-white w3-round-medium w3-margin-bottom">
                                    <div class="w3-row">
                                        <div class="w3-quarter">
                                            <span style="padding-right: 50px; font-family: Arial; font-weight: bold; font-size: 18px; text-transform: uppercase; color: rgb(236, 116, 4); margin-bottom: 10px;">
                                                MERCREDI*
                                            </span>
                                        </div>
                                        <div class="w3-rest">
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="wednesday_yes" value="1" v-model="schedule_wednesday_checked">&nbsp;
                                                <label for="wednesday_yes">Oui</label>
                                            </span>
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="wednesday_no" value="0" v-model="schedule_wednesday_checked">&nbsp;
                                                <label for="wednesday_no">Non</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="w3-row">
                                        <input id="wednesday_schedule_hours"  class="w3-input" style="border: 1px solid lightgrey; border-radius: 5px; padding: 5px; background-color: white; color: grey;" v-if="schedule_wednesday_checked==1" v-model="schedule_wednesday_hours" placeholder="Précisez horaires et semaine A ou B :">
                                    </div>
                                </div>
                            </div>

                            <div class="w3-container w3-half w3-mobile" style="padding: 10px;">
                                <div class="w3-padding w3-white w3-round-medium w3-margin-bottom">
                                    <div class="w3-row">
                                        <div class="w3-quarter">
                                            <span style="padding-right: 50px; font-family: Arial; font-weight: bold; font-size: 18px; text-transform: uppercase; color: rgb(236, 116, 4); margin-bottom: 10px;">
                                                JEUDI*
                                            </span>
                                        </div>
                                        <div class="w3-rest">
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="thursday_yes" value="1" v-model="schedule_thursday_checked">&nbsp;
                                                <label for="thursday_yes">Oui</label>
                                            </span>
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="thursday_no" value="0" v-model="schedule_thursday_checked">&nbsp;
                                                <label for="thursday_no">Non</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="w3-row">
                                        <input id="thursday_schedule_hours"  class="w3-input" style="border: 1px solid lightgrey; border-radius: 5px; padding: 5px; background-color: white; color: grey;" v-if="schedule_thursday_checked==1" v-model="schedule_thursday_hours" placeholder="Précisez horaires et semaine A ou B :">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w3-row">
                            <div class="w3-container w3-half w3-mobile" style="padding: 10px;">
                                <div class="w3-padding w3-white w3-round-medium w3-margin-bottom">
                                    <div class="w3-row">
                                        <div class="w3-quarter">
                                            <span style="padding-right: 50px; font-family: Arial; font-weight: bold; font-size: 18px; text-transform: uppercase; color: rgb(236, 116, 4); margin-bottom: 10px;">
                                                VENDREDI*
                                            </span>
                                        </div>
                                        <div class="w3-rest">
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="friday_yes" value="1" v-model="schedule_friday_checked">&nbsp;
                                                <label for="friday_yes">Oui</label>
                                            </span>
                                            <span style="padding-right: 20px;">
                                                <input type="radio" id="friday_no" value="0" v-model="schedule_friday_checked">&nbsp;
                                                <label for="friday_no">Non</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="w3-row">
                                        <input id="friday_schedule_hours"  class="w3-input" style="border: 1px solid lightgrey; border-radius: 5px; padding: 5px; background-color: white; color: grey;" v-if="schedule_friday_checked==1" v-model="schedule_friday_hours" placeholder="Précisez horaires et semaine A ou B :">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w3-row">
                            <div class="w3-container w3-mobile w3-right">
                                <div class="mandatory_info_text2">* Champs obligatoires</div>
                            </div>
                        </div>
                        <div class="w3-row">&nbsp;</div>

                    </div>

                </div>


                <div style="height: 20px;"></div>
                <div class="w3-row">
                    <span class="modules_availabilities_section_title">Souhaitez-vous apporter des précisions ?*</span>
                    <div style="margin-bottom: 10px;"></div>
                </div>
                <div class="w3-row">
                    <div class="w3-container w3-quarter">
                        <div>
                            <div class="w3-cell">
                                <input type="radio" class="" id="modules_radio_button_details_info_yes" value="1" v-model="details_infos_check">
                                <label for="modules_radio_button_details_info_yes" class="modules_radio_button">Oui</label>
                            </div>
                            <div class="w3-cell">
                                <input type="radio" class="" id="modules_radio_button_details_info__no" value="0" v-model="details_infos_check">
                                <label for="modules_radio_button_details_info__no" class="modules_radio_button">Non</label>
                            </div>
                        </div>
                        <div style="margin-bottom: 16px;"></div>
                        <div class="mandatory_info_text2">* Champ obligatoire</div>
                    </div>
                    <div class="w3-container w3-threequarter" >
                        <textarea class="modules_availabilities_infos" v-if="details_infos_check==1" v-model="details_infos" placeholder="Précisez votre matière, la période souhaitée, vos projets en lien avec l'eau, etc [4500 caractères]"></textarea>
                    </div>
                </div>
            </div>
            <div style="height: 20px;"></div>

            <div class="w3-panel w3-red w3-center modules_alert" v-if="IsSendingButtonWarningTextDisplayed">
                <p>{{ SendingButtonWarningText }}</p>
            </div>

            <div class="w3-panel w3-red w3-center modules_alert" v-if="sending_error">
                <p>UNE ERREUR S'EST PRODUITE LORS DE L'ENVOI DU FORMULAIRE D'INSCRIPTION</p>
                <p>VOTRE INSCRIPTION N'A PAS &Eacute;T&Eacute; PRISE EN COMPTE</p>
                <p>VEUILLEZ CLIQUER &Agrave; NOUVEAU SUR LE BOUTON "ENVOYER L'INSCRIPTION"</p>
                <p>SI LE PROBLEME PERSISTE VOUS POUVEZ PRENDRE CONTACT AVEC LE SYNDICAT DE L'ORGE</p>
            </div>

            <div class="w3-row w3-mobile w3-center">
                <div class="w3-col">
                    <div v-if="IsSendingButtonDisabled">Une fois ce formulaire envoyé, vous recevrez un mail avec le récapitulatif de votre demande.</div>
                    <br>
                    <button class="w3-center w3-btn w3-mobile w3-round-large w3-xlarge w3-ripple modules_send_button" v-bind:disabled="IsSendingButtonDisabled" v-on:click="submitWithCaptcha()">ENVOYER L'INSCRIPTION</button>
                    <div v-if="!IsSendingButtonDisabled">
                        <br>
                        <div>Veuillez vérifier votre boîte de réception e-mail (et si besoin votre boîte SPAM).</div>
                        <div><strong>Si vous ne recevez pas le mail de confirmation, veuillez nous contacter.</strong></div>
                    </div>
                </div>
            </div>

            <div style="height: 50px;"></div>
            <div class="w3-row w3-mobile">
                <div class="w3-center">
                    <img src="./images/ModulesCollege/attention.svg" alt="attention" height="32px" width="32px" />
                </div>
                <div class="w3-center">
                    <span class="modules_send_registration_warning">VOTRE INSCRIPTION N'EST PAS D&Eacute;FINITIVE, CHAQUE FORMULAIRE EST SOUMIS &Agrave; VALIDATION.</span>
                </div>
                <div class="w3-center modules_title5">Nous vous contacterons par mail au <strong>cours de l'année</strong> environ <strong>1 mois avant la date proposée.</strong> </div>
            </div>
            <div style="height: 20px;"></div>
            

            <!-- The Modal -->
            <div id="id01" class="w3-modal" style="display: block; opacity: 0.85; background-color: #EC7404;" v-if="disable_sending_button">
                <div class="spinner circles">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="w3-center spinner_text">VOTRE FORMULAIRE EST EN COURS D'ENVOI</div>
            </div>

        </div>

        <div v-else class="w3-center">

            <div class="modules_title0" style="margin-top: 64px;">Votre demande d’inscription a bien été prise en compte.</div>

            <div class="w3-section">
                <img src="./images/ModulesCollege/attention.svg" alt="attention" height="32px" width="32px" />
                <span class="modules_send_registration_warning">VOTRE INSCRIPTION N'EST PAS D&Eacute;FINITIVE, CHAQUE FORMULAIRE EST SOUMIS &Agrave; UNE S&Eacute;LECTION.</span>
            </div>


            <span class="w3-section modules_title5">Nous vous contacterons par mail au <strong>cours de l'année</strong> environ <strong>1 mois avant la date proposée.</strong></span>

            <div class="w3-section">
                <router-link to="/">
                    <img src="./images/ModulesCollege/accueil.svg" alt="classe" height="20px" width="68px" />
                </router-link>
            </div>
        </div>

        <div v-if="debug==1">
            <p>returned_data: {{ returned_data }} </p>
            <p>returned_status: {{ returned_status }} </p>
            <p>error_message: {{ error_message }} </p>
            <p>disable_sending_button: {{ disable_sending_button }} </p>
            <p>school_name: {{ school_name }} </p>
            <p>civility_check: {{ civility_check }} </p>
            <p>school_teacher: {{ school_teacher }} </p>
            <p>school_address: {{ school_address }} </p>
            <p>school_phone: {{ school_phone }} </p>
            <p>school_class: {{ school_class }} </p>
            <p>school_city: {{ school_city }} </p>
            <p>school_pupils_nb: {{ school_pupils_nb }} </p>
            <p>school_teacher_email: {{ school_teacher_email }} </p>
            <p>school_teacher_mobile: {{ school_teacher_mobile }} </p>
            <p>school_phone: {{ school_phone }} </p>

            <p>workshops_to_attend_biodiversity: {{ workshops_to_attend_biodiversity }} </p>
            <p>workshops_to_attend_responsible_consommation: {{ workshops_to_attend_responsible_consommation }} </p>
            <p>workshops_to_attend_anthropogenic_impacts_on_natural_env: {{ workshops_to_attend_anthropogenic_impacts_on_natural_env }} </p>
            <p>workshops_to_attend_climate_change: {{ workshops_to_attend_climate_change }} </p>
            <p>workshops_to_attend_water_issues_around_the_world: {{ workshops_to_attend_water_issues_around_the_world }} </p>

            <p>details_infos_check: {{ details_infos_check }} </p>
            <p>details_infos: {{ details_infos }} </p>

        </div>

        <vue-programmatic-invisible-google-recaptcha ref="invisibleRecaptcha1"
                                                     :sitekey="'6LelM7UUAAAAABrw5GqPXvDJby9bW37zMmlGahLq'"
                                                     :elementId="'invisibleRecaptcha1'"
                                                     :badgePosition="'left'"
                                                     :showBadgeMobile="false"
                                                     :showBadgeDesktop="false"
                                                     @recaptcha-callback="submit"></vue-programmatic-invisible-google-recaptcha>


        <FooterSivoaVue />
    </div>
</template>

<script>
    import HeaderSivoaVue from './HeaderSivoa.vue';
    import FooterSivoaVue from './FooterSivoa.vue';
    import axios from 'axios';

    export default {
        name: 'modules_college_vue',
        data() {
            return {
                debug: 0,
                returned_data: '',
                returned_status: 0,
                error_message: '',
                sending_error: false,
                registering_done: 0,
                disable_sending_button: false,
                school_name_id: -1,
                school_name: '',
                school_address: '',
                school_city: '',
                school_teacher: '',
                school_class: '',
                school_pupils_nb: -1,
                school_teacher_email: '',
                school_teacher_mobile: '',
                school_phone: '',
                workshops_to_attend_biodiversity: [],
                workshops_to_attend_responsible_consommation: [],
                workshops_to_attend_anthropogenic_impacts_on_natural_env: [],
                workshops_to_attend_climate_change: [],
                workshops_to_attend_water_issues_around_the_world: [],
                schedule_monday_checked: -1,
                schedule_monday_hours: '',
                schedule_tuesday_checked: -1,
                schedule_tuesday_hours: '',
                schedule_wednesday_checked: -1,
                schedule_wednesday_hours: '',
                schedule_thursday_checked: -1,
                schedule_thursday_hours: '',
                schedule_friday_checked: -1,
                schedule_friday_hours: '',
                civility_check: '',
                details_infos_check: -1,
                details_infos: '',
                city_list: [
                    { id: 1, city_name: 'ATHIS MONS' },
                    { id: 2, city_name: 'BRETIGNY SUR ORGE' },
                    { id: 3, city_name: 'BRIIS SOUS FORGES' },
                    { id: 4, city_name: 'DOURDAN' },
                    { id: 5, city_name: 'EPINAY SUR ORGE' },
                    { id: 6, city_name: 'GRIGNY' },
                    { id: 7, city_name: 'JUVISY SUR ORGE' },
                    { id: 8, city_name: 'LA NORVILLE' },
                    { id: 9, city_name: 'LIMOURS' },
                    { id: 10, city_name: 'MARCOUSSIS' },
                    { id: 11, city_name: 'MAROLLES EN HUREPOIX' },
                    { id: 12, city_name: 'MONTLHERY' },
                    { id: 13, city_name: 'MORSANG SUR ORGE' },
                    { id: 14, city_name: 'NOZAY' },
                    { id: 15, city_name: 'OLLAINVILLE' },
                    { id: 16, city_name: 'PARAY VIEILLE POSTE' },
                    { id: 17, city_name: 'SAVIGNY SUR ORGE' },
                    { id: 18, city_name: 'SAINT-CHERON' },
                    { id: 19, city_name: 'SAINT GERMAIN LES ARPAJON' },
                    { id: 20, city_name: 'SAINT MICHEL SUR ORGE' },
                    { id: 21, city_name: 'SAINTE GENEVIEVE DES BOIS' },
                    { id: 22, city_name: 'VILLEMOISSON SUR ORGE' },
                    { id: 23, city_name: 'VIRY CHATILLON' },
                ],
                school_list: [],
            }
        },
        components: {
            HeaderSivoaVue,
            FooterSivoaVue
        },
        mounted () {
        },
        created: function () {
            this.schoolList('');
        },
        methods: {
            ComputeSelectedWorkshopsHours: function () {
                var iWorkshopsHour0 = 2*this.workshops_to_attend_biodiversity.length;
                var iWorkshopsHour1 = 2*this.workshops_to_attend_responsible_consommation.length;
                var iWorkshopsHour2 = 2*this.workshops_to_attend_anthropogenic_impacts_on_natural_env.length;
                var iWorkshopsHour3 = this.workshops_to_attend_climate_change.length * 3;
                var iWorkshopsHour4 = this.workshops_to_attend_water_issues_around_the_world.length * 2;
                var iWorkshopsTotalHours = iWorkshopsHour0 + iWorkshopsHour1 + iWorkshopsHour2 + iWorkshopsHour3 + iWorkshopsHour4;
                return iWorkshopsTotalHours;
            },
            bGotModules: function() {
                var iWorkshopsTotalHours = this.ComputeSelectedWorkshopsHours();
                return iWorkshopsTotalHours > 0 && iWorkshopsTotalHours <= 6;
            },
            bGotPlanning: function() {
                return this.schedule_monday_checked != -1 && this.schedule_tuesday_checked != -1 && this.schedule_wednesday_checked != -1 && this.schedule_thursday_checked != -1 && this.schedule_friday_checked != -1;
            },
            bGotSchoolInfo: function() {
                return this.school_name.length > 0 &&
                    this.school_teacher.length > 0 &&
                    this.school_address.length > 0 &&
                    this.school_class.length > 0 &&
                    this.school_city.length > 0 &&
                    this.school_pupils_nb > 0 &&
                    this.school_teacher_email.length > 0 &&
                    this.school_teacher_mobile.length > 0 &&
                    this.school_phone.length > 0 &&
                    this.civility_check.length > 0;
            },
            validateEmail(email) {
                if (!email) return true;
                return /\S+@\S+\.\S+/.test(email)
            },
            selectAllResponsibleConsommation() {
                if (this.workshops_to_attend_responsible_consommation.length == 2) {
                    this.workshops_to_attend_responsible_consommation = [];
                } else {
                    this.workshops_to_attend_responsible_consommation = ['atelier 1', 'atelier 2'];
                }
            },
            selectAllAnthropogenicImpactsOnNaturalEnv() {
                if (this.workshops_to_attend_anthropogenic_impacts_on_natural_env.length == 2) {
                    this.workshops_to_attend_anthropogenic_impacts_on_natural_env = [];
                } else {
                    this.workshops_to_attend_anthropogenic_impacts_on_natural_env = ['atelier 1', 'atelier 2'];
                }
            },
            selectAllBiodiversity() {
                if (this.workshops_to_attend_biodiversity.length == 3) {
                    this.workshops_to_attend_biodiversity = [];
                } else {
                    this.workshops_to_attend_biodiversity = ['atelier 1', 'atelier 2', 'atelier 3'];
                }
            },
            schoolList(city) {
                axios({
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        url: 'php/school_list.php',
                        data: {
                            type: 'COLLEGE',
                            city: city,
                        },
                    })
                    .then((response) => {
                        this.school_list = response.data;   //id, type, school_name, school_address, school_city, school_phone
                        this.sending_error = false;
                    }).
                    catch((error) => {
                        this.error_message = error;
                        this.sending_error = true;
                    })
            },
            selectSchool() {
                this.quota_error = false;

                var found = this.school_list.find(element => element.id == this.school_name_id);
                if (found) {
                    this.school_city = found.school_city;
                    this.school_name = found.school_name;
                    this.school_phone = found.school_phone;
                    this.school_address = found.school_address;
                }
            },
            selectCity() {
                this.school_name_id = -1;
                this.school_name = "";
                this.school_phone = "";
                this.school_address = "";
                this.schoolList (this.school_city);
            },
            submitWithCaptcha() {
                this.$refs.invisibleRecaptcha1.execute();
            },
            submit: async function (recaptchaToken) {
                this.disable_sending_button = true;

                var w0 = '';
                for (let workshop of this.workshops_to_attend_biodiversity) {
                    w0 += workshop + "|";
                }

                var w1 = '';
                for (let workshop of this.workshops_to_attend_responsible_consommation) {
                    w1 += workshop + "|";
                }
                var w2 = '';
                for (let workshop of this.workshops_to_attend_anthropogenic_impacts_on_natural_env) {
                    w2 += workshop + "|";
                }

                var w3 = '';
                for (let workshop of this.workshops_to_attend_climate_change) {
                    w3 += workshop + "|";
                }

                var w4 = '';
                for (let workshop of this.workshops_to_attend_water_issues_around_the_world) {
                    w4 += workshop + "|";
                }

                var json_data = {
                    school_year: '2024',
                    cycle: 3,
                    school_name: this.school_name,
                    school_address: this.school_address,
                    school_city: this.school_city,
                    school_teacher: this.civility_check + ' ' + this.school_teacher,
                    school_class: this.school_class,
                    school_pupils_nb: this.school_pupils_nb,
                    school_teacher_email: this.school_teacher_email,
                    school_teacher_mobile: this.school_teacher_mobile,
                    school_phone: this.school_phone,
                    workshops_to_attend_biodiversity: w0,
                    workshops_to_attend_responsible_consommation: w1,
                    workshops_to_attend_anthropogenic_impacts_on_natural_env: w2,
                    workshops_to_attend_climate_change: w3,
                    workshops_to_attend_water_issues_around_the_world: w4,
                    schedule_monday_checked: this.schedule_monday_checked,
                    schedule_monday_hours: this.schedule_monday_hours,
                    schedule_tuesday_checked: this.schedule_tuesday_checked,
                    schedule_tuesday_hours: this.schedule_tuesday_hours,
                    schedule_wednesday_checked: this.schedule_wednesday_checked,
                    schedule_wednesday_hours: this.schedule_wednesday_hours,
                    schedule_thursday_checked: this.schedule_thursday_checked,
                    schedule_thursday_hours: this.schedule_thursday_hours,
                    schedule_friday_checked: this.schedule_friday_checked,
                    schedule_friday_hours: this.schedule_friday_hours,
                    details_infos_check: this.details_infos_check,
                    details_infos: this.details_infos,
                    token: recaptchaToken,
                };

                this.sending_error = false;

                // Send email
                await axios({
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        url: 'php/college_mail.php',
                        data: json_data,
                    })
                    .then((response) => {
                        console.log("Email sent status: " + response.status);
                    }).
                    catch((error) => {
                        this.error_message = error;
                        this.sending_error = true;
                    });

                if (!this.sending_error) await axios({
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    url: 'php/postdata_mc.php',
                    data: json_data,
                })
                .then((response) => {
                    this.returned_data = response.data;
                    this.returned_status = response.status;
                    this.sending_error = false;
                    this.registering_done = 1;
                }).
                catch((error) => {
                    this.error_message = error;
                    this.sending_error = true;
                })

                this.disable_sending_button = false;
            },
        },
        computed: {
            IsSendingButtonDisabled: function () {
                var bButtonEnabled = this.bGotSchoolInfo() && this.bGotModules() &&  this.bGotPlanning() && this.details_infos_check != -1 && !this.disable_sending_button;
                return !bButtonEnabled;
            },
            SendingButtonWarningText: function () {
                var iWorkshopsTotalHours = this.ComputeSelectedWorkshopsHours();

                if (!this.bGotSchoolInfo()) {
                    return "Veuillez sélectionner un collège et saisir les informations de l'enseignant";
                }
                else if (iWorkshopsTotalHours == 0) {
                    return "Vous devez sélectionner au moins 1 atelier";
                }
                else if (iWorkshopsTotalHours > 6) {
                    return "Vous ne pouvez sélectionner que 6 heures d'ateliers maximum";
                }
                else if (!this.bGotPlanning()) {
                    return "Veuillez sélectionner un horaire";
                }
                else if (!this.validateEmail(this.school_teacher_email)) {
                    return "Mauvais format de votre e-mail";
                }
                else if (this.details_infos_check == -1) {
                    return "Veuillez renseigner si vous avez des précisions à apporter ou non";
                }
                else {
                    return "";
                }
            },
            IsSendingButtonWarningTextDisplayed: function () {
                if (!this.bGotSchoolInfo()) {
                    return 1;
                }
                else if (!this.bGotModules()) {
                    return 1;
                }
                else if (!this.bGotPlanning()) {
                    return 1;
                }
                else if (!this.validateEmail(this.school_teacher_email)) {
                    return 1;
                }
                else if (this.details_infos_check == -1) {
                    return 1;
                }
                else {
                    return 0;
                }
            },

        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import url('../assets/spinner.css');
    
    * {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    select:required:invalid {
        color: #999999;
    }

    option[value=""][disabled] {
        display: none;
    }

    ::placeholder {
        color: #999999;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #999999;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #999999;
    }

    .modules_college {
        margin-left: 37px;
        margin-right: 37px;
    }

    .modules_title0 {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 32px;
        text-transform: uppercase;
        color: rgb(108, 56, 42);
        font-style: normal;
    }

    .modules_textbox_font {
        font-family: Arial;
        font-size: 12px;
    }

    .mandatory_info_text {
        font-family: 'Roboto', sans-serif;
        font-size: 10px;
        color: rgb(255, 255, 255);
        padding-left: 5px;
    }

    .mandatory_info_text2 {
        font-family: 'Roboto', sans-serif;
        font-size: 10px;
        color: rgb(0, 0, 0);
        padding-left: 5px;
    }

    #external_workshop_only_text {
        font-family: 'Roboto', sans-serif;
        font-size: 12px;
        color: rgb(255, 255, 255);
    }

    .modules_send_registration_warning {
        font-family: Arial;
        font-size: 16px;
        text-transform: uppercase;
        color: rgb(237, 28, 36);
        text-align: justify;
        text-justify: inter-word;
    }

    .modules_alert {
        font-family: Arial;
        font-size: 16px;
        text-transform: uppercase;
    }

    .modules_send_button {
        font-family: 'Roboto Condensed', sans-serif;
        font-style: normal;
        color: #FFFFFF;
        outline: 0;
        background: #EC7404;
    }
    .modules_send_button:disabled {
        font-family: 'Roboto Condensed', sans-serif;
        font-style: normal;
        color: #FFFFFF;
        outline: 0;
        background: rgb(179,179,179);
    }

    #modules_orange_text {
        color: rgb(236, 116, 4);
    }

    .modules_title1 {
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 21px;
        text-transform: uppercase;
        color: rgb(108, 56, 42);
        margin-bottom: 5px;
    }

    .modules_title2 {
        font-family: Arial;
        font-weight: bold;
        font-size: 16px;
        color: rgb(236, 116, 4);
    }

    .modules_title3 {
        font-family: Arial;
        font-weight: bold;
        font-size: 16px;
        color: rgb(108, 56, 42);
        margin-bottom: 5px;
    }

    .modules_title4 {
        font-family: Arial;
        font-weight: bold;
        font-size: 16px;
        color: #009AA3;
        color: rgb(0, 154, 163);
        margin-bottom: 5px;
    }

    .modules_choices_section0_box {
        border-style: Solid;
        border-color: rgba(108, 56, 42, 1);
        border-width: 4px;
        border-radius: 20px;
        -moz-border-radius: 20px;
        -webkit-border-radius: 20px;
        padding-left: 5px;
        padding-right: 15px;
        padding-top: 15px;
        padding-bottom: 15px;
        margin-bottom: 20px;
    }

    .modules_choices_choice_title {
        font-family: Arial;
        font-weight: bold;
        font-size: 18px;
        color: rgb(236, 116, 4);
        margin-left: 35px;
    }





    .modules_choices_choice_title2 {
        font-family: Arial;
        font-weight: bold;
        font-size: 18px;
        color: #6c382a;
        margin-left: 15px;
    }




    .modules_choices_choice_title_section1 {
        font-family: Arial;
        font-weight: bold;
        font-size: 18px;
        color: #009aa3;
    }

    .modules_choices_choice_text0 {
        font-family: Arial;
        font-size: 16px;
        color: rgb(108, 56, 42);
        margin-left: 15px;
        padding-bottom: 10px;
        margin-left: 35px;
    }

    .modules_choices_choice_text0_section1 {
        font-family: Arial;
        font-size: 16px;
        color: rgb(108, 56, 42);
        margin-bottom: 10px;
    }


    .modules_choices_choice_item {
        background-color: #e2d7d4;
        border-radius: 10px;
        margin: 2px;
        padding: 10px;
        font-family: Arial;
        font-size: 14px;
        color: #6c382a;
    }
    .modules_choices_choice_item_selected {
        background-color: #6c382a;
        border-radius: 10px;
        margin: 2px;
        padding: 10px;
        font-family: Arial;
        font-size: 14px;
        color: white;
    }
    .modules_choices_choice_item_disabled {
        background-color: rgba(230, 230, 230, 1);
        border-radius: 10px;
        margin: 2px;
        padding: 10px;
        font-family: Arial;
        font-size: 14px;
        color:rgb(120,120,120);
    }


    .modules_right_choices_choice_item {
        background-color: #ccebed;
        border-radius: 10px;
        margin: 2px;
        padding: 10px;
        font-family: Arial;
        font-size: 14px;
        color: #6c382a;
    }
    .modules_right_choices_choice_item_selected {
        background-color: #009aa3;
        border-radius: 10px;
        margin: 2px;
        padding: 10px;
        font-family: Arial;
        font-size: 14px;
        color: white;
    }


    .workshops_choices_choice_item {
        background-color: rgb(254, 232, 211);
        border-radius: 10px;
        margin: 2px;
        padding: 10px;
        font-family: Arial;
        font-size: 14px;
        color: rgb(236, 116, 4);
    }
    .workshops_choices_choice_item_selected {
        background-color: rgb(236, 116, 4);
        border-radius: 10px;
        margin: 2px;
        padding: 10px;
        font-family: Arial;
        font-size: 14px;
        color: white;
    }




    .modules_choices_choice_item_checkbox_text {
        font-family: Arial;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        color: rgb(0, 0, 0);
    }

    .modules_choices_choice_item_text {
        font-family: Arial;
        font-size: 14px;
        color: rgb(236, 116, 4);
    }





    .modules_choices_section1_box {
        border-style: Solid;
        border-color: #009AA3;
        border-color: rgba(0, 154, 163, 1);
        border-width: 4px;
        border-radius: 20px;
        -moz-border-radius: 20px;
        -webkit-border-radius: 20px;
        padding: 15px;
        margin-bottom: 20px;
    }

    .modules_choices_section0_bottom_text {
        font-family: Arial;
        font-size: 14px;
        color: #000000;
        color: rgb(0, 0, 0);
        margin-bottom: 16px;
    }

    .modules_title5 {
        font-family: Arial;
        font-size: 14px;
        color: #000000;
        color: rgb(0, 0, 0);
    }

    .modules_title6 {
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 19px;
        text-transform: uppercase;
        color: rgb(108, 56, 42);
        margin-bottom: 16px;
    }

    .modules_availabilities_section_title {
        font-family: Arial;
        font-weight: bold;
        font-size: 14px;
        color: rgb(236, 116, 4);
    }

    .modules_availabilities_infos {
        font-family: Arial;
        font-size: 12px;
        color: #000000;
        color: rgb(0, 0, 0);
        width: 100%;
        resize: vertical;
        height: 120px;
    }

    .modules_radio_button {
        font-family: Arial;
        font-size: 14px;
        color: #000000;
        color: rgb(0, 0, 0);
        margin-left: 10px;
        margin-right: 10px;
    }



    /* The container */
    .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    }

    /* Hide the browser's default radio button */
    .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    }

    /* Create a custom radio button */
    .checkmark {
    position: absolute;
    top: 2px;
    left: 2px;
    height: 25px;
    width: 25px;
    background-color: #ddd;
    border-radius: 50%;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
    background-color: #ccc;
    }

    /* When the radio button is checked, add a blue background */
    .container input:checked ~ .checkmark {
    background-color: rgb(236, 116, 4);
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .checkmark:after {
    content: "";
    position: absolute;
    display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .container input:checked ~ .checkmark:after {
    display: block;
    }

    /* Style the indicator (dot/circle) */
    .container .checkmark:after {
        top: 7px;
        left: 7px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: white;
    }


    input[type='radio'] {
        width: 18px;
        height: 18px;
        accent-color: rgb(236, 116, 4);
        background-color: white;
        border: 1px solid rgb(236, 116, 4);;
        appearance: none; /* Enlever le style par défaut du navigateur */
        border-radius: 50%; /* Pour garder la forme circulaire */
        display: inline-block;
        position: relative;
        cursor: pointer;

        margin: 0; /* Supprime les marges par défaut */
        padding: 0; /* Supprime les padding par défaut */
        vertical-align: middle; /* Alignement vertical au milieu */
    }

    input[type='radio']:checked {
        background-color: white; /* Fond blanc lorsqu'il est sélectionné */
    }

    input[type='radio']:checked::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60%;
        height: 60%;
        background-color: rgb(236, 116, 4);; /* Point vert */
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    input[type='radio']:hover {
        background-color: white; /* Fond blanc au survol */
    }



    /* The container */
    .blue_container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    }

    /* Hide the browser's default radio button */
    .blue_container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    }

    /* Create a custom radio button */
    .blue_checkmark {
    position: absolute;
    top: 2px;
    left: 2px;
    height: 25px;
    width: 25px;
    background-color: #ddd;
    border-radius: 50%;
    }

    /* On mouse-over, add a grey background color */
    .blue_container:hover input ~ .blue_checkmark {
    background-color: #ccc;
    }

    /* When the radio button is checked, add a blue background */
    .blue_container input:checked ~ .blue_checkmark {
    background-color: #009aa3;
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .blue_checkmark:after {
    content: "";
    position: absolute;
    display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .blue_container input:checked ~ .blue_checkmark:after {
    display: block;
    }

    /* Style the indicator (dot/circle) */
    .blue_container .blue_checkmark:after {
        top: 7px;
        left: 7px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: white;
    }


    .blue_container input[type='radio'] {
        width: 18px;
        height: 18px;
        accent-color: #009aa3;
        background-color: white;
        border: 1px solid #009aa3;
        appearance: none; /* Enlever le style par défaut du navigateur */
        border-radius: 50%; /* Pour garder la forme circulaire */
        display: inline-block;
        position: relative;
        cursor: pointer;
    }

    .blue_container input[type='radio']:checked {
        background-color: white; /* Fond blanc lorsqu'il est sélectionné */
    }

    .blue_container input[type='radio']:checked::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60%;
        height: 60%;
        background-color: #009aa3;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    .blue_container input[type='radio']:hover {
        background-color: white; /* Fond blanc au survol */
    }



    /* The container */
    .brown_container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    }

    /* Hide the browser's default radio button */
    .brown_container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    }

    /* Create a custom radio button */
    .brown_checkmark {
    position: absolute;
    top: 2px;
    left: 2px;
    height: 25px;
    width: 25px;
    background-color: #ddd;
    border-radius: 50%;
    }

    /* On mouse-over, add a grey background color */
    .brown_container:hover input ~ .brown_checkmark {
    background-color: #ccc;
    }

    /* When the radio button is checked, add a blue background */
    .brown_container input:checked ~ .brown_checkmark {
    background-color: #6c382a;
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .brown_checkmark:after {
    content: "";
    position: absolute;
    display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .brown_container input:checked ~ .brown_checkmark:after {
    display: block;
    }

    /* Style the indicator (dot/circle) */
    .brown_container .brown_checkmark:after {
        top: 7px;
        left: 7px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: white;
    }


    .brown_container input[type='radio'] {
        width: 18px;
        height: 18px;
        accent-color: #6c382a;
        background-color: white;
        border: 1px solid #6c382a;
        appearance: none; /* Enlever le style par défaut du navigateur */
        border-radius: 50%; /* Pour garder la forme circulaire */
        display: inline-block;
        position: relative;
        cursor: pointer;
    }

    .brown_container input[type='radio']:checked {
        background-color: white; /* Fond blanc lorsqu'il est sélectionné */
    }

    .brown_container input[type='radio']:checked::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60%;
        height: 60%;
        background-color: #6c382a;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    .brown_container input[type='radio']:hover {
        background-color: white; /* Fond blanc au survol */
    }
</style>